import axios from 'axios';

export function requestWithCancel(url, conf, type = 'get') {
  let source = axios.CancelToken.source();
  if (conf) conf.cancelToken = source.token;
  return {
    source: source,
    request: type == 'post' ? axios.post(url, conf) : axios.get(url, conf),
  };
}

export function requestPostWithCancel(url, params) {
  let source = axios.CancelToken.source();
  return {
    source: source,
    request: axios.post(url, params, { cancelToken: source.token }),
  };
}

export function randomGuidGenerator() {
  var S4 = function () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
}

export function blobUrlToBlob(url) {
  return new Promise((resolve, reject) => {
    let blobUrl = url;

    let xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';

    xhr.onload = function () {
      let recoveredBlob = xhr.response;

      let reader = new FileReader();

      reader.onload = function () {
        let blobAsDataUrl = reader.result;
      };

      reader.readAsDataURL(recoveredBlob);

      resolve(recoveredBlob);
    };

    xhr.open('GET', blobUrl);
    xhr.send();
  });
}

export function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function () {
      let base64data = reader.result;
      resolve(base64data);
    };
  });
}
